import { Icon } from "@/components/icon";
import type { NavProps } from "@/components/nav";
import { P } from "@/constants/permissions";

export const navData: NavProps["data"] = [
	{
		name: "sys.menu.management",
		items: [
			{
				title: "merchantManagement",
				path: "/pw_management/merchant",
				icon: <Icon icon="material-symbols:storefront" size={24} />,
				children: [
					{
						title: "merchantList",
						path: "/pw_management/merchant",
						permission: P.MERCHANT_READ,
					},
					{
						title: "checkoutOrders",
						path: "/pw_management/checkout_orders",
						permission: P.FIAT_CHECKOUT_ORDER_READ,
					},
				],
			},
			{
				title: "walletsManagement",
				path: "/pw_management/wallets",
				icon: <Icon icon="material-symbols:account-balance-wallet" size={24} />,
				children: [
					{
						title: "wallets.walletList",
						path: "/pw_management/wallets",
						permission: [P.CRYPTO_WALLET_READ, P.FIAT_WALLET_READ],
					},
				],
			},
			{
				title: "rateManagement",
				path: "/pw_management/rate",
				icon: <Icon icon="material-symbols:currency-exchange" size={24} />,
				children: [
					{
						title: "rateList",
						path: "/pw_management/rate",
						permission: P.FIAT_EXCHANGE_RATE_READ,
					},
				],
			},
			{
				title: "posEventManagement",
				path: "/pw_management/pos_event",
				icon: <Icon icon="material-symbols:calendar-clock" size={24} />,
				children: [
					{
						title: "posEventList",
						path: "/pw_management/pos_event",
						permission: P.EVENT_SERVICE_INFO_READ,
					},
				],
			},
			{
				title: "fiatDistribution.title",
				path: "/pw_management/fiat_distribution",
				icon: <Icon icon="material-symbols:paid" size={24} />,
				children: [
					{
						title: "fiatDistribution.list",
						path: "/pw_management/fiat_distribution",
						permission: P.FIAT_DISTRIBUTION_READ,
					},
					{
						title: "fiatDistribution.payoutGatewayBalance",
						path: "/pw_management/payout_gateway_balances",
						permission: P.FIAT_PAYOUT_GATEWAY_BALANCE_READ,
					},
				],
			},
			{
				title: "withdrawalOrder.title",
				path: "/pw_management/withdrawal_orders",
				icon: <Icon icon="mingcute:bank-card-line" size={24} />,
				children: [
					{
						title: "withdrawalOrder.list",
						path: "/pw_management/withdrawal_orders",
						permission: P.FIAT_WITHDRAWAL_ORDER_READ,
					},
				],
			},
		],
	},
];
